var _ClientSideComponent;
import { Suspense, lazy } from "react";
import ClientSideComponent from "../../../ClientSideComponent";
import { jsx as _jsx } from "react/jsx-runtime";
var CallCenter = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "main-menu-call-center" */"./CallCenter");
});
var LazyCallCenter = function LazyCallCenter() {
  return _ClientSideComponent || (_ClientSideComponent = /*#__PURE__*/_jsx(ClientSideComponent, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: null,
      children: /*#__PURE__*/_jsx(CallCenter, {})
    })
  }));
};
export default LazyCallCenter;